import { render, staticRenderFns } from "./DeptList.vue?vue&type=template&id=044daa4e&"
import script from "./DeptList.vue?vue&type=script&lang=js&"
export * from "./DeptList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports